module.exports = global.config = {
    animations: {
        stagger: {
            animate: {
                transition: {
                    staggerChildren: 0.05
                }
            }
        },
        particlesBox : {
            initial: {
                opacity: 0,
            },
            animate: {
                opacity: 1,
                transition: {
                    duration: 1.2,
                    ease: [0.6, -0.05, 0.01, 0.99],
                }
            }
        },
        changeColorNav: {
            color: {
                backgroundColor: "rgba(0, 24, 69, 1)",
                transition: {
                    duration: 0.4
                }
            },
            transparent: {
                backgroundColor: "rgba(0, 24, 69, 0)",
                transition: {
                    duration: 0.4
                }
            }
        },
        fadeInNav: {
            initial: {
                y: 60,
                opacity: 0
            },
            animate: {
                y: 0,
                opacity: 1,
                color: 'black',
                transition: {
                    duration: 0.6,
                    ease: [0.6, -0.05, 0.01, 0.99],
                    delay: 0.8
                }
            },
            hover: {
                scale: 1.3,
                transition: {
                    duration: 0.4,
                    ease: [0.6, -0.05, 0.01, 0.99]
                }
            },
        },
        headerText: {
            initial: {
                y: 60,
                opacity: 0
            },
            animate: {
                y: 0,
                opacity: 1,
                color: 'black',
                transition: {
                    duration: 0.6,
                    ease: [0.6, -0.05, 0.01, 0.99],
                    delay: 0.8
                }
            },
            hover: {
                scale: 1.3,
                transition: {
                    duration: 0.4,
                    ease: [0.6, -0.05, 0.01, 0.99]
                }
            },
            color_black: {
                color: 'black',
            },
            color_white: {
                color: 'white',
            },
        },
        buttonBanner: {
            initial: {
                y: 60,
                opacity: 0
            },
            animate: {
                y: 0,
                opacity: 1,
                transition: {
                    duration: 0.6,
                    ease: [0.6, -0.05, 0.01, 0.99],
                    delay: 1
                }
            }
        },
        containerStagger: {
            initial: { opacity: 0 },
            animate: {
                opacity: 1,
                transition: {
                    staggerChildren: 0.3,
                }
            }
        },
        fadeInText: {
            initial: {
                y: 60,
                opacity: 0
            },
            animate: {
                y: 0,
                opacity: 1,
                transition: {
                    delay: 1,
                    duration: 0.6,
                    ease: [0.6, -0.05, 0.01, 0.99]
                }
            },
        },
        fadeInTextServices: {
            initial: {
                y: 60,
                opacity: 0
            },
            animate: {
                y: 0,
                opacity: 1,
                transition: {
                    duration: 0.6,
                    ease: [0.6, -0.05, 0.01, 0.99]
                }
            },
        },
        fadeInClientsBox: {
            initial: {
                x: 80,
                opacity: 0
            },
            animate: {
                x: 0,
                opacity: 1,
                transition: {
                    delay: 1.2,
                    duration: 1,
                    ease: [0.6, -0.05, 0.01, 0.99]
                }
            },
        },
        fadeInBox: {
            initial: {
                y: 60,
                opacity: 0,
                transition: {duration: 0.6, ease: [0.6, -0.05, 0.01, 0.99]}
            },
            animate: {
                y: 0,
                opacity: 1,
                transition: {
                    duration: 0.6,
                    ease: [0.6, -0.05, 0.01, 0.99]
                }
            },
        },
    },
    projects: [
        {
            id: 1,
            title: "Castello di Nelson",
            place: "Bronte",
            client: "Comune di Bronte",
            description: "Prestazioni professionali relative alla verifica di resistenza al fuoco, alla progettazione e alla certificazione antincendio degli elementi strutturali/edili e alla progettazione di un nuovo impianto sprinkler all’interno del reparto “Caroselli” presente al piano rialzato dell’edificio D (crudo) dello stabilimento LAVAZZA di Torino.",
            year: "2020",
            placeholder: "./../assets/images/wedding.jpg"
        },
        {
            id: 2,
            title: "Castello",
            place: "Bronte",
            client: "Comune di Bronte",
            description: "Progetto basato sulla riqualifica della rete elettrica e dell'impianto di sicurezza.",
            year: "2020",
            placeholder: "./../assets/images/rocks.jpg"
        },
        {
            id: 3,
            title: "Castello di Bra",
            place: "Bronte",
            client: "Comune di Bronte",
            description: "Progetto basato sulla riqualifica della rete elettrica e dell'impianto di sicurezza.",
            year: "2020",
            placeholder: "./../assets/images/mountainskies.jpg"
        }
        ]
};
